import { render } from "./NavbarUserInfos.vue?vue&type=template&id=3d4e5720&scoped=true&ts=true&lang=pug"
import script from "./NavbarUserInfos.vue?vue&type=script&lang=ts"
export * from "./NavbarUserInfos.vue?vue&type=script&lang=ts"

import "./NavbarUserInfos.vue?vue&type=style&index=0&id=3d4e5720&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4e5720"]])

export default __exports__